export const objectToGetParams = (object)=> {
  return '?' + Object.keys(object)
    .filter(key => !!object[key])
    .map(key => `${key}=${encodeURIComponent(object[key])}`)
    .join('&')
}


// WEBPACK FOOTER //
// ./src/lib/utils.js